/**
 * Validates if an email belongs to an allowed domain by properly parsing
 * and sanitizing the email address.
 *
 * @param email - The email address to validate
 * @returns true if the email domain is in the allowed list, false otherwise
 */
export function isAllowedEmailDomain(email: string | undefined | null): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }

  // Trim and convert to lowercase for consistent comparison
  const sanitizedEmail = email.trim().toLowerCase();

  // Basic email format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(sanitizedEmail)) {
    return false;
  }

  // Extract the domain part (everything after @)
  const parts = sanitizedEmail.split('@');
  if (parts.length !== 2) {
    return false;
  }

  const domain = parts[1];

  // Explicit list of allowed domains
  const allowedDomains = ['versori.com', 'versori.io'];

  // Check if the domain exactly matches one of the allowed domains
  return allowedDomains.includes(domain);
}
